import { z } from "zod";
import { CUSTOM_FIELD_TYPES } from "@/api/types";

/**
 * Zod schema for the custom-field admin form. Backend mirror:
 * `CustomFieldSchemaCreate` (recognition.api.schemas).
 */
export const customFieldFormSchema = z.object({
  entity_type: z.enum(["client", "employee"]),
  key: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-zA-Z0-9_]+$/),
  label: z.string().min(1).max(255),
  field_type: z.enum(CUSTOM_FIELD_TYPES),
  is_required: z.boolean().optional(),
  is_filterable: z.boolean().optional(),
  order: z.number().int().min(0).optional(),
});

export type CustomFieldFormValues = z.infer<typeof customFieldFormSchema>;

export function defaultCustomFieldFormValues(
  entity_type: "client" | "employee",
): CustomFieldFormValues {
  return {
    entity_type,
    key: "",
    label: "",
    field_type: "text",
    is_required: false,
    is_filterable: true,
    order: 0,
  };
}
